import { registerPlugin } from '@capacitor/core';

import { PushNotificationsPluginInterface } from './definitions';
import { CAPACITOR_PUSH_NOTIFICATIONS_PLUGIN } from '../pluginConstants';

const PushNotificationsPlugin = registerPlugin<PushNotificationsPluginInterface>(CAPACITOR_PUSH_NOTIFICATIONS_PLUGIN);

export * from './definitions';
export { PushNotificationsPlugin };
